import { BookingColumnKey } from './types';

export const columnKeys: BookingColumnKey[] = ['Id', 'BookedBy', 'CompanyId', 'Status', 'From'];
